import { render, staticRenderFns } from "./SectionXidContact.vue?vue&type=template&id=f1876066&scoped=true"
import script from "./SectionXidContact.vue?vue&type=script&lang=ts"
export * from "./SectionXidContact.vue?vue&type=script&lang=ts"
import style0 from "./SectionXidContact.vue?vue&type=style&index=0&id=f1876066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1876066",
  null
  
)

export default component.exports